<template>
  <div class="print">
    <ResumeRenderer v-if="resume" :resume="resume" :items="items" :is-printing="true" />
  </div>
</template>

<script>
import ResumeRenderer from '@/components/ResumeRenderer';
import { mapGetters } from 'vuex';

export default {
  name: 'PrintView',
  components: {
    ResumeRenderer,
  },
  computed: {
    ...mapGetters(['currentResume']),
    resume() {
      return this.currentResume;
    },
    items() {
      if (this.resume) return this.resume.items;
      return [];
    },
  },
  created() {
    const apikey = this.$route.query.apikey;
    if (apikey) {
      this.$store.dispatch('auth.setAccessToken', apikey);
    }
  },
  async mounted() {
    try {
      await this.$store.dispatch('resumes.getCurrent', this.$route.params.id);
    } catch (e) {
      console.error("can't get resume");
    }
  },
};
</script>

<style lang="scss">
@media print {
  * {
    overflow: visible !important;
  }

  .print {
    overflow: hidden !important;
  }

  @page {
    size: A4 portrait;
    padding: 0;
    margin: 0;
    break-after: page;
  }

  .page {
    break-after: page !important;
    margin: 0 !important;
    box-shadow: none !important;

    &:last-child {
      break-after: avoid !important;
    }
  }

  .yeets {
    .page {
      &:nth-last-child(-n + 2) {
        break-after: avoid !important;
      }
    }
  }
}
</style>
